import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/Fox-River-AI-Logo.png';

const PublicHeader = () => {
  const navigate = useNavigate();
  
  const goToHomePage = () => {
    navigate('/');
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Blog', path: '/blog' },
    { name: 'Learn More', path: '/app' },
    { name: 'Contact Us', path: '/contact-us' },
    { name: 'Admin', path: '/admin/blog' }
  ];

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-left" onClick={goToHomePage} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Company Logo" className="logo" />
          <div className="company-info">
            <h1 className="company-name">Fox River AI</h1>
            <p className="slogan">Provable, local-first AI for agentic systems and ML pipelines.</p>
          </div>
        </div>
        <div className="header-right">
          <p className="contact-info">Call today: (630) 940-8837</p>
        </div>
      </div>
      <nav className="scrollable-nav">
        <div className="menu-container">
          {navItems.map((item, index) => (
            <div className="nav-item" key={index}>
              <button 
                onClick={() => navigate(item.path)}
                style={{ 
                  background: 'none', 
                  border: 'none', 
                  color: 'inherit', 
                  cursor: 'pointer',
                  padding: '0',
                  font: 'inherit'
                }}
              >
                {item.name}
              </button>
            </div>
          ))}
        </div>
      </nav>
    </header>
  );
};

export default PublicHeader;